import { LenderConfiguration } from '@shared/model/lender-config.model';
import { Component } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';

/**
 * Component representing page not found Api call
 * NOTE: This page is currently being used for AppInit failures in a "stripped down" mode.
 * We should ask UI/UX for guidance on how this should look.
 * @Component
 */
@Component({
  selector: 'cu-generic-error',
  templateUrl: './generic_error.component.html'
})
/**
 * Class representing generic error page
 * @export
 * @class GenericErrorComponent
 */
export class GenericErrorComponent {
  /** Lender configuration data */
  public lenderConfig: LenderConfiguration;

  constructor(public lenderService: LenderService) {
    this.lenderConfig = this.lenderService.lenderDataInfo;
  }
}
